import { t } from "i18next"; 

export const Paths = {
  Agreements: "/agreements",
  AuthResponse: "/auth-response",
  ConfirmAddress: "/confirm-address",
  ConfirmDetails: "/confirm-details",
  ConfirmVehicle: "/confirm-vehicle",
  Error: "/error",
  FinalEstimatedQuote: "/estimated-quote",
  FinalQuote: "/final-quote",
  Home: "/",
  IneligibleAftermarket: t('ineligible-reasons.ineligible-aftermarket.path'),
  IneligibleLiftkit: t('ineligible-reasons.ineligible-liftkit.path'), 
  IneligibleMileage: t('ineligible-reasons.ineligible-mileage.path'), 
  IneligibleMultiple: t('ineligible-reasons.ineligible-multiple.path'), 
  InelgibleNoQualifyingInspections: t('ineligible-reasons.ineligible-no-qualifying-inspections.path'),
  IneligibleQuoteError: t('ineligible-reasons.ineligible-quote-error.path'),
  IneligibleVehicle: t('ineligible-reasons.ineligible-reason.path'),
  IneligibleVehicleClass: t('ineligible-reasons.ineligible-vehicleclass.path'), 
  IneligibleVIN: t('ineligible-reasons.ineligible-vin.path'),
  IneligibleYear: t('ineligible-reasons.ineligible-year.path'), 
  LogIn: "/log-in",
  Payment: "/payment",
  Questionnaire: "/questionnaire",
  TermsAndConditions: "/terms-and-conditions",
  ThankYou: "/thank-you",
  Welcome: "/welcome"
};
